import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyRegularSavingPlanComponent } from './my-regular-saving-plan/my-regular-saving-plan.component';
import { FormsModule } from '@angular/forms';
import { ShareModule } from '@app/shared/shared.module';
import { MyRetirementPlanComponent } from '@app/features/my-needs/my-retirement-plan/my-retirement-plan.component';
import { MyIncomeProtectionComponent } from '@app/features/my-needs/my-income-protection/my-income-protection.component';
import { MyCapitalNeedsComponent } from '@app/features/my-needs/my-capital-needs/my-capital-needs.component';
import { MyHealthPlanComponent } from '@app/features/my-needs/my-health-plan/my-health-plan.component';

@NgModule({
  declarations: [
    MyRegularSavingPlanComponent,
    MyRetirementPlanComponent,
    MyIncomeProtectionComponent,
    MyCapitalNeedsComponent,
    MyHealthPlanComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ShareModule
  ],
  exports: [
    MyRegularSavingPlanComponent,
    MyRetirementPlanComponent,
    MyIncomeProtectionComponent,
    MyCapitalNeedsComponent,
    MyHealthPlanComponent
  ]
})
export class MyNeedsModule { }



// WEBPACK FOOTER //
// ./src/app/features/my-needs/my-needs.module.ts